<template>
  <div
    id="navBar"
    :class="{
      'transparent' : isTransparent,
      'isGallery' : isGallery,
      }"
  >
    <div class="pos">
    </div>

    <div class="pos">
      <div
        v-if="currentRoomIndex !== null || infoActive"
        class="btn back"
      >
        <BackSVG @click="handleBack()"/>
      </div>

      <div
        v-else
        class="floorsDots"
      >
        <ul>
          <li
            v-for="floorIndex in floorsLength"
            :key="floorIndex"
          >
            <div
              class="btnDot"
              @click="setFloorIndex(floorIndex-1)"
            >
              <div
                class="dot"
                :class="{'highlight': currentFloorIndex === floorIndex-1}"
              >
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="pos">
      <div
        v-if="currentRoomIndex === null && !infoActive"
        class="btn info"
      >
        <InfoSVG @click="setInfoActive(true)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BackSVG from '../../public/svg/back.svg';
import InfoSVG from '../../public/svg/info.svg';

export default {
  components: {
    BackSVG,
    InfoSVG,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['currentFloorIndex', 'currentRoomIndex', 'currentExhibit', 'currentPlayerGallery', 'currentGalleryItem', 'playerAudioActive', 'floorsLength', 'infoActive', 'imageZoomed']),
    isGallery() {
      return (this.currentPlayerGallery !== null);
    },
    isTransparent() {
      return ((this.currentPlayerGallery !== null && this.currentGalleryItem === null)
        || this.imageZoomed);
    },
  },
  methods: {
    ...mapActions(['setFloorIndex', 'setRoomIndex', 'setExhibit', 'setPlayerGalleryItem', 'setPlayerActive', 'setPlayerAudioActive', 'setInfoActive', 'setImageZoomed']),
    handleBack() {
      // console.log(this.currentPlayerGallery);
      if (this.imageZoomed) {
        this.setImageZoomed(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' Back To Player');
      } else if (this.currentPlayerGallery !== null && this.currentGalleryItem !== null) {
        this.setPlayerAudioActive(false);
        this.setPlayerGalleryItem(null);
        // this.setImageZoomed(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' Back To Gallery');
      } else if (this.currentExhibit !== null) {
        this.setPlayerActive(false);
        // this.setExhibit(null);
        this.$router.push({ name: 'Room', params: { roomId: this.currentRoomIndex } });
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' Back To Room');
      } else if (this.currentRoomIndex !== null) {
        this.setRoomIndex(null);
        this.$router.push({ name: 'Floor', params: { floorId: this.currentFloorIndex } });
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' Back To Floor');
      } else if (this.infoActive) {
        this.setInfoActive(false);
        if (process.env.VUE_APP_DEBUG === 'on') console.log(' Close Info');
      }
    },
  },
};
</script>

<style scoped lang="scss">
#navBar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height:9vh;
  height: calc(var(--vh, 1vh) * 9);
  background-color: #eee;
  background-color: var(--main-background-color);
  display: flex;
  justify-content: center;
  align-items: center;

  transition: background-color .5s;
  transition-delay: .5s;

  .pos {
    flex: 1;
  }
  .btn {
    width: 40px;
    height: 40px;

    svg {
      width: 100%;
      height: 100%;
      fill: var(--main-elements-color);
    }
  }
  &.transparent {
    background-color: transparent;
    transition: none;
    .btn {
      svg {
        fill: white;
      }
    }
  }

  .floorsDots {
    display: flex;
    justify-content: center;
    align-items: center;

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;

      li {
        margin: 0;
        padding: 0;
      }
    }
    .btnDot{
      padding: 10px 5px;

      .dot {
        width: 10px;
        height: 10px;
        min-width: 10px;
        min-height: 10px;
        border-radius: 100px;
        background-color: var(--main-elements-color);

        &.highlight{
          background-color: var(--main-elements-active-color);
        }
      }
    }
  }
  .back,
  .info {
    margin: 0 auto;
  }
}
@media only screen and (orientation : landscape) {
  #navBar {

    &.isGallery {
      background-color: transparent;
      transition: none;

      .btn {
        width: 8vh;
        width: calc(var(--vh, 1vh) * 8);
        height: 8vh;
        height: calc(var(--vh, 1vh) * 8);
        max-width: 50px;
        max-height: 50px;

        svg {
          fill: white;
        }
      }
    }
  }
}
@media only screen and (orientation : landscape) and (min-aspect-ratio: 3/2) {
  #navBar {
    &.isGallery {
      .btn {
        background-color: var(--main-background-color);
        border-radius: 50px;
        padding: 3px 5px;
        svg {
          fill: var(--main-elements-color);
        }
      }
    }
  }
}
</style>
